import Ajax from "Utils/ajax";
export const getStaffOnProbation = (data) => Ajax.post('hr/getStaffOnProbation',data);
export const getProbationDate = (data) => Ajax.post('hr/getProbationDate',data);
export const probationCompletionProcess = (data) => Ajax.post('hr/probationCompletionProcess',data);